import { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

const AI_CONSENT_KEY = 'ai_consent_given';

export function useAIConsent() {
  const [consentGiven, setConsentGiven] = useState(null); // null = loading
  const [showConsentModal, setShowConsentModal] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);

  useEffect(() => {
    checkConsent();
  }, []);

  const checkConsent = async () => {
    try {
      if (Capacitor.isNativePlatform()) {
        const { value } = await Preferences.get({ key: AI_CONSENT_KEY });
        setConsentGiven(value === 'true');
      } else {
        const value = localStorage.getItem(AI_CONSENT_KEY);
        setConsentGiven(value === 'true');
      }
    } catch {
      setConsentGiven(false);
    }
  };

  const saveConsent = async (given) => {
    try {
      if (Capacitor.isNativePlatform()) {
        await Preferences.set({ key: AI_CONSENT_KEY, value: String(given) });
      } else {
        localStorage.setItem(AI_CONSENT_KEY, String(given));
      }
      setConsentGiven(given);
    } catch (e) {
      console.error('Failed to save consent:', e);
    }
  };

  // Call this before any AI feature — pass the action to run after consent
  const requireConsent = (action) => {
    if (consentGiven) {
      action();
    } else {
      setPendingAction(() => action);
      setShowConsentModal(true);
    }
  };

  const handleAccept = async () => {
    await saveConsent(true);
    setShowConsentModal(false);
    if (pendingAction) {
      pendingAction();
      setPendingAction(null);
    }
  };

  const handleDecline = () => {
    setShowConsentModal(false);
    setPendingAction(null);
  };

  return {
    consentGiven,
    showConsentModal,
    requireConsent,
    handleAccept,
    handleDecline,
  };
}